"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fab = void 0;
const core_1 = require("@material-ui/core");
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const PlusIcon_1 = __importDefault(require("@opsbase/web-icons/icons/PlusIcon"));
const react_1 = __importStar(require("react"));
const makeMyClasses = fabStyle => ({
    root: Object.assign({ zIndex: 100, position: 'fixed', bottom: 8, right: 8, pointerEvents: 'none' }, fabStyle),
    fab: {
        pointerEvents: 'all',
    },
});
const transitionDuration = {
    enter: 0.3,
    exit: 0.3,
};
function Fab(props) {
    const { onClick, disabled, icon = react_1.default.createElement(PlusIcon_1.default, null), fabStyle = {} } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [fabStyle]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(core_1.Zoom, { in: true, timeout: transitionDuration, unmountOnExit: true },
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 8, direction: "row", justify: "flex-end", alignItems: "center", className: myCss.root },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Fab, { className: myCss.fab, disabled: disabled, color: "primary", onClick: onClick }, icon))))), [disabled, icon, myCss === null || myCss === void 0 ? void 0 : myCss.fab, myCss === null || myCss === void 0 ? void 0 : myCss.root, onClick]);
}
exports.Fab = Fab;
exports.default = Fab;
